import { useLoading } from '../providers/loading_provider'
import { useSnackBar } from '../providers/snack_bar_provider'
import { ApiErrorResponse, handleError } from '../services/network'
import { AttachmentInfo } from '../types/chat'

type UseImageUploadProps = {
  upload: (file: File) => Promise<AttachmentInfo | null>
}

export const useImageUpload = (): UseImageUploadProps => {
  const { showLoading, hideLoading } = useLoading()
  const { showSnackBar } = useSnackBar()

  const upload = async (file: File): Promise<AttachmentInfo | null> => {
    const fd = new FormData()
    fd.append('file', file)

    showLoading()

    const result = await fetch(
      `${process.env.REACT_APP_KYOUSOU_API_BASE_URL}/upload/image`,
      {
        method: 'POST',
        body: fd,
      }
    )
      .then((response) => response.json())
      .then((data) => ({ url: data.url, fileName: data.fileName }))
      .catch((e: ApiErrorResponse) => {
        handleError(e, showSnackBar)
        hideLoading()
        return null
      })
      .finally(() => {
        hideLoading()
      })

    return result
  }

  return {
    upload,
  }
}